// Country name -> ISO2, so a flag can be shown next to any country the map turns up.
const ISO2 = {
  "Trinidad & Tobago": "TT", "Trinidad and Tobago": "TT", "Jamaica": "JM", "Barbados": "BB",
  "Guyana": "GY", "Grenada": "GD", "Saint Lucia": "LC", "St Lucia": "LC",
  "Antigua and Barbuda": "AG", "Dominica": "DM", "St Kitts and Nevis": "KN",
  "Saint Kitts and Nevis": "KN", "St Vincent and the Grenadines": "VC",
  "Saint Vincent and the Grenadines": "VC", "Anguilla": "AI", "Montserrat": "MS",
  "The Bahamas": "BS", "Bahamas": "BS", "Belize": "BZ", "Bermuda": "BM",
  "Cayman Islands": "KY", "Dominican Republic": "DO", "Haiti": "HT", "Cuba": "CU",
  "Suriname": "SR", "Aruba": "AW", "Curaçao": "CW", "Curacao": "CW", "Puerto Rico": "PR",
  "United States": "US", "USA": "US", "US": "US", "Canada": "CA", "Mexico": "MX",
  "Panama": "PA", "Costa Rica": "CR", "Guatemala": "GT", "Honduras": "HN", "Nicaragua": "NI",
  "El Salvador": "SV", "Brazil": "BR", "Argentina": "AR", "Colombia": "CO", "Chile": "CL",
  "Peru": "PE", "Ecuador": "EC", "Uruguay": "UY", "Paraguay": "PY", "Bolivia": "BO",
  "Venezuela": "VE", "United Kingdom": "GB", "UK": "GB", "Ireland": "IE", "France": "FR",
  "Germany": "DE", "Spain": "ES", "Italy": "IT", "Portugal": "PT", "Netherlands": "NL",
  "Belgium": "BE", "Austria": "AT", "Switzerland": "CH", "Sweden": "SE", "Norway": "NO",
  "Denmark": "DK", "Finland": "FI", "Poland": "PL", "Czechia": "CZ", "Czech Republic": "CZ",
  "Hungary": "HU", "Romania": "RO", "Greece": "GR", "Croatia": "HR", "Iceland": "IS",
  "Luxembourg": "LU", "Malta": "MT", "Cyprus": "CY", "Estonia": "EE", "Latvia": "LV",
  "Lithuania": "LT", "Slovakia": "SK", "Slovenia": "SI", "Turkey": "TR",
  "United Arab Emirates": "AE", "UAE": "AE", "Saudi Arabia": "SA", "Qatar": "QA",
  "Kuwait": "KW", "Bahrain": "BH", "Oman": "OM", "Israel": "IL", "Jordan": "JO",
  "Egypt": "EG", "Morocco": "MA", "Tunisia": "TN", "Nigeria": "NG", "Ghana": "GH",
  "Kenya": "KE", "Tanzania": "TZ", "Uganda": "UG", "Rwanda": "RW", "Ethiopia": "ET",
  "South Africa": "ZA", "Namibia": "NA", "Botswana": "BW", "Zimbabwe": "ZW", "Zambia": "ZM",
  "India": "IN", "Pakistan": "PK", "Bangladesh": "BD", "Sri Lanka": "LK", "Nepal": "NP",
  "China": "CN", "Hong Kong": "HK", "Taiwan": "TW", "Japan": "JP", "South Korea": "KR",
  "Singapore": "SG", "Malaysia": "MY", "Thailand": "TH", "Vietnam": "VN", "Indonesia": "ID",
  "Philippines": "PH", "Cambodia": "KH", "Australia": "AU", "New Zealand": "NZ", "Fiji": "FJ",
};

const emoji = (code) => String.fromCodePoint(...code.split("").map((c) => 127397 + c.charCodeAt(0)));

export const flagFor = (country) => {
  const code = ISO2[country] || ISO2[(country || "").trim()];
  return code ? emoji(code) : "\u{1F3F3}\uFE0F";
};

export default flagFor;
